export default __webpack_public_path__ + "media/images/mailer/logo-9d204b24a21608a5df4ae29c60df60e6.png";